import { TNewRequestFormFieldType } from "components/ProjectSpecificComponents/Interfaces/FormsInterface"
import { TAnyValuesObject } from "components/ProjectSpecificComponents/Interfaces/GlobalInterface"
import { useState, useMemo } from "react"
import { TSortConfig, TSortDirection } from "../Interfaces/Interfaces"

export const useSortData = (data: TAnyValuesObject[]) => {
	const [sortConfig, setSortConfig] = useState<TSortConfig | null>(null)
	// numeric(true) - numeric collation will be used when sorting
	// sensitivity(base) - strings that do not have the same base letters are considered unequal
	const localeCompareoptions = {
		numeric: true,
		sensitivity: "base",
	}
	const sortedItems = useMemo(() => {
		let sortableItems: TAnyValuesObject[] = [...data]
		if (!sortConfig) return sortableItems
		sortableItems.sort((a, b) => {
			const currKey = a[sortConfig.key]
			const nextKey = b[sortConfig.key]

			const isReversed = sortConfig.direction === "ascending" ? 1 : -1
			// Default sort doesn't work for date format.
			if (sortConfig?.type == "DATE") {
				// From DD/MM/YYYY to YYYYMMDD
				const transformedCurrKey = currKey.split("/").reverse().join("")
				const transformedNextKey = nextKey.split("/").reverse().join("")
				return (
					isReversed *
					transformedCurrKey.localeCompare(transformedNextKey, undefined, localeCompareoptions)
				)
			}

			return isReversed * String(currKey).localeCompare(nextKey, undefined, localeCompareoptions)
		})

		return sortableItems
	}, [data, sortConfig])

	const requestSort = (key: string, type: string) => {
		let direction: TSortDirection = "ascending"
		if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
			direction = "descending"
		}
		setSortConfig({ key, direction, type })
	}

	return { items: sortedItems, requestSort, sortConfig, setSortConfig }
}

export default useSortData
